<div id="radialbar-chart">
    <apx-chart [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [plotOptions]="chartOptions.plotOptions"
        [colors]="chartOptions.colors"
        [labels]="chartOptions.labels">
    </apx-chart>
</div>